module.exports = __webpack_public_path__ + "img/home-cat-2.3ca4070b.jpg";